import { render, staticRenderFns } from "./ArticlesInHistory.vue?vue&type=template&id=c75b5142&scoped=true"
import script from "./ArticlesInHistory.vue?vue&type=script&lang=js"
export * from "./ArticlesInHistory.vue?vue&type=script&lang=js"
import style0 from "./ArticlesInHistory.vue?vue&type=style&index=0&id=c75b5142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75b5142",
  null
  
)

export default component.exports